<template>
  <div>
    <h3 class="popover-title">
      <span
        v-if="selectedOrderId"
        v-t="'NUMBER_ORDER'"
      />
      <dropdown
        v-if="!selectedOrderId"
        tag="span"
        :menu-right="false"
        class="bulk-actions-dropdown"
      >
        <btn
          size="sm"
          data-cy="order-time-options"
        >
          {{ $t(selectedTimeOption.text) }}
          <span class="caret" />
        </btn>

        <template slot="dropdown">
          <li>
            <a
              v-for="timeOption in timeOptions"
              :key="timeOption.id"
              v-t="timeOption.text"
              class="btn bulk-actions-dropdown__btn"
              data-cy="order-time-option"
              @click="onSelectedTimeOption(timeOption)"
            />
          </li>
        </template>
      </dropdown>
      <a
        class="close"
        @click.prevent="closeModal"
      >
        <i
          class="typcn typcn-delete"
          aria-hidden="true"
        />
      </a>
    </h3>
    <NumberOrderList
      v-if="!selectedOrderId"
      :orders="orders"
      :status="getOrdersStatus"
      :timezone="accountTranslatedTimeZoneId"
      @selected="orderSelected"
    />
    <NumberOrder
      v-if="selectedOrderId"
      :order="selectedOrder"
      :status="getSelectedOrderStatus"
      :timezone="accountTranslatedTimeZoneId"
      @back="onBack"
      @cancelOrder="onCancelOrder"
    />
  </div>
</template>

<script>
import NumberOrderList from './NumberOrderList';
import NumberOrder from './NumberOrder';
import { mapActions, mapState, mapGetters } from 'vuex';
import { CANCEL_NUMBER_ORDER, GET_NUMBER_ORDERS, SELECT_NUMBER_ORDER, UNSELECT_NUMBER_ORDER } from '../../store/actionTypes';
import messages from '../../locales';

export default {
  components: {
    NumberOrderList,
    NumberOrder
  },
  computed: {
    ...mapState('number', ['orders', 'selectedOrderId', 'selectedOrder']),
    ...mapGetters('number', ['getSelectedOrderStatus', 'getOrdersStatus']),
    ...mapGetters(['accountTranslatedTimeZoneId'])
  },
  data() {
    return {
      timeOptions: [
        {
          id: 'WEEK',
          text: 'ORDERS_TIMEFRAME_WEEK'
        },
        {
          id: 'MONTH',
          text: 'ORDERS_TIMEFRAME_MONTH'
        },
        {
          id: 'ALLTIME',
          text: 'ORDERS_TIMEFRAME_ALL_TIME'
        }
      ],
      selectedTimeOption: {
        id: 'WEEK',
        text: 'ORDERS_TIMEFRAME_WEEK'
      },
    };
  },
  mounted() {
    this.getOrders(this.selectedTimeOption.id);
    this.getPublishers();
  },
  methods: {
    ...mapActions('number', {
      'getOrders': GET_NUMBER_ORDERS,
      'cancelOrder': CANCEL_NUMBER_ORDER,
      'selectOrder': SELECT_NUMBER_ORDER,
      'unselectOrder': UNSELECT_NUMBER_ORDER
    }),
    ...mapActions('users', ['getPublishers']),
    onSelectedTimeOption(timeOption) {
      this.selectedTimeOption = timeOption;
      this.getOrders(this.selectedTimeOption.id);
    },
    orderSelected(order) {
      this.selectOrder(order.id);
    },
    onBack() {
      this.unselectOrder();
    },
    onCancelOrder(id) {
      this.unselectOrder();
      this.cancelOrder(id);
    },
    closeModal() {
      this.$emit('closeModal');
    }
  },
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>